// src/services/apiService.js
import axios from 'axios';

// API基本URL - 根据你的Hostinger设置调整
const API_BASE_URL = '/api'; // 使用相对路径，或者设置为你的完整URL，例如 'https://yourdomain.com/api'

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加错误处理和加载指示器等
api.interceptors.request.use(
  (config) => {
    // 可以在这里添加请求拦截逻辑
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 统一处理错误等
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 处理网络错误、超时等
    let errorMessage = 'Network error. Please try again.';
    
    if (error.response) {
      // 服务器返回错误
      errorMessage = error.response.data.message || `Server error: ${error.response.status}`;
    } else if (error.request) {
      // 请求发出但没有收到响应
      errorMessage = 'Server not responding. Please try again.';
    }
    
    console.error('API Error:', errorMessage, error);
    return Promise.reject({ message: errorMessage });
  }
);

// 任务相关API方法
const taskService = {
  // 获取所有活动任务
  getTasks: async () => {
    try {
      const response = await api.get('/tasks.php?action=getTasks');
      return response.data || [];
    } catch (error) {
      console.error('Error fetching tasks:', error);
      return [];
    }
  },
  
  // 获取历史任务
  getHistoryTasks: async () => {
    try {
      const response = await api.get('/tasks.php?action=getHistoryTasks');
      return response.data || [];
    } catch (error) {
      console.error('Error fetching history tasks:', error);
      return [];
    }
  },
  
  // 更新任务列表（整体替换）
  updateTasks: async (tasks) => {
    return api.post('/tasks.php?action=updateTasks', tasks);
  },
  
  // 更新历史任务列表
  updateHistoryTasks: async (historyTasks) => {
    return api.post('/tasks.php?action=updateHistoryTasks', historyTasks);
  },
  
  // 添加单个任务
  addTask: async (task) => {
    return api.post('/tasks.php?action=addTask', task);
  },
  
  // 完成任务
  completeTask: async (taskId) => {
    return api.post('/tasks.php?action=completeTask', { taskId });
  },
  
  // 删除任务
  deleteTask: async (taskId) => {
    return api.post('/tasks.php?action=deleteTask', { taskId });
  }
};

// 认证相关API方法
const authService = {
  // 用户登录
  login: async (username) => {
    try {
      const response = await api.post('/auth.php?action=login', { username });
      if (response.success) {
        // 保存认证信息到sessionStorage
        sessionStorage.setItem('authData', JSON.stringify(response.data));
      }
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },
  
  // 验证令牌
  validateToken: async (authData) => {
    try {
      const response = await api.post('/auth.php?action=validateToken', authData);
      return response.success;
    } catch (error) {
      console.error('Token validation error:', error);
      return false;
    }
  },
  
  // 获取当前认证的用户
  getCurrentUser: () => {
    try {
      const authDataStr = sessionStorage.getItem('authData');
      if (!authDataStr) return null;
      
      const authData = JSON.parse(authDataStr);
      
      // 检查认证是否有效
      if (authData && authData.expiresAt && new Date().getTime() < authData.expiresAt) {
        return authData.username;
      }
      
      // 认证已过期
      sessionStorage.removeItem('authData');
      return null;
    } catch (error) {
      console.error('Error getting current user:', error);
      sessionStorage.removeItem('authData');
      return null;
    }
  },
  
  // 登出
  logout: () => {
    sessionStorage.removeItem('authData');
  }
};

export { taskService, authService };